// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/auth/flow/AuthPageStyles.module.css';
import type {Icon} from '@phosphor-icons/react';
import {QuestionIcon} from '@phosphor-icons/react';

interface AuthErrorStateProps {
	icon?: Icon;
	title: React.ReactNode;
	text: React.ReactNode;
}
export function AuthErrorState({icon: IconComponent = QuestionIcon, title, text}: AuthErrorStateProps) {
	return (
		<div className={styles.errorContainer}>
			<div className={styles.errorIcon}>
				<IconComponent className={styles.errorIconSvg} />
			</div>
			<h1 className={styles.errorTitle}>{title}</h1>
			<p className={styles.errorText}>{text}</p>
		</div>
	);
}
